import React from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { Link, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import {
    Typography,
    Container,
    Grid,
    Backdrop,
    CircularProgress,
    useTheme,
    Link as MuiLink,
  } from "@material-ui/core";
import { CloudDownload, Edit } from "@material-ui/icons";
import { EditReportResults } from "./EditReportResult";
import { Toast } from "react-toastify/dist/components";
import { toast } from "react-toastify";
import { LSDBCoreTableNoSrink } from "../../../common/LSDBCoreTableNoSrink";
import { DefineDataDialog } from "../define_reports/DefineDataDialog";


export const AssignedReportsList = ({ data }: any) => {

     const history = useHistory();

     const dateFormatter = (dateToFormat: Date) => {
      return `${dateToFormat.toDateString()} ${dateToFormat
        .getUTCHours()
        .toString()
        .padStart(2, "0")}:${dateToFormat
        .getUTCMinutes()
        .toString()
        .padStart(2, "0")}:${dateToFormat
        .getUTCSeconds()
        .toString()
        .padStart(2, "0")}`;
    };
    //  const {
    //   data: workOrderData,
    //   isError: isErrorReportResult,
    //   isSuccess: isSuccessReportResult,
    //   error: errorReportResult,
    //   isLoading: isLoadingReportResult
    // } = useReportResult(work_order_id); 

      const columns = React.useMemo(
       
        () => [
              {
                id: "Id",
                accessor: "id",
              },
              {
                id: "work_order_id",
                accessor: "work_order_id",
              },
              {
                Header: "Report Type             ",
                accessor:"report_type_definition_name",
               
                Cell: ({ row }: any) => (
                  <Button
                    variant="contained"
                    color="primary"
                  >
                    {row.values.report_type_definition_name}
                  </Button>
              )
                
              },
              {
                accessor:"due_date",
                id:"due_date",
                Cell: ({ row }: any) => {
                  return row.values.due_date === null ? (
                    <p>N/A</p>
                  ) : (
                    <p>{dateFormatter(new Date(row.values.due_date))}</p>
                  );
                }
              
              },
              {
                accessor:"issue_date",
                id:"issue_date",
                Cell: ({ row }: any) => {
                  return row.values.issue_date === null ? (
                    <p>N/A</p>
                  ) : (
                    <p>{dateFormatter(new Date(row.values.issue_date))}</p>
                  );
                }
              },
              {
                accessor:"report_writer_name",
                id:"report_writer_name",
                Cell: ({ row }: any) => {
                  return row.values.report_writer_name === null ? (
                    <p>N/A</p>
                  ) : (
                    <p>{row.values.report_writer_name}</p>
                  );
                }
              },
              {
                accessor:"report_approver_name",
                id:"report_approver_name",
                Cell: ({ row }: any) => {
                  return row.values.report_approver_name === null ? (
                    <p>N/A</p>
                  ) : (
                    <p>{row.values.report_approver_name}</p>
                  );
                }
              },
              {
                accessor:"data_ready_status",
                id:"data_ready_statuss",
                Cell: ({ row }: any) => {
                  return   (
                    <div>
                      <MuiLink
                        // component={Link}
                        // to={`/project_management/project_intelligence/${row.values.id}`}
                        style={{ color: data[row.index].hex_color }}
                      >
                      <DefineDataDialog report_data ={row.values}/>
                      </MuiLink>
                    </div>
                  );
                }
              },
              {
                accessor:"status_disposition_name",
                id:"status_disposition_name",
                Cell: ({ row }: any) => {
                  return row.values.status_disposition_name === null ? (
                    <p>N/A</p>
                  ) : (
                    <p>{row.values.status_disposition_name}</p>
                  );
                }
              },
              {
                Header: "Edit", // No header
                id: "edit", 
                Cell: ({ row }: any) => (
                <div>
                {/* <Button
                 color="primary"
                //  onClick={}
                 startIcon={<Edit />}
                /> */}
                <MuiLink
                    component={Link}
                    to={`/project_management/customer/${row.values.id}`}>
                    {row.values.Project}
                </MuiLink>
                  {console.log(data[row.index])}
                <EditReportResults report_data ={data[row.index]}/>
                 
                
                </div>
                ),
              },
              {
                Header: "Download", // No header
                id: "azurefile_download", 
                Cell: ({ row }: any) => (
                <div>
                <Button
                 color="primary"
                 onClick={handleDownload}
                 startIcon={<CloudDownload />}
                 data-report={JSON.stringify(data[row.index])}
                />
                </div>
                ),  
              }
            ],
           []
      );  

    return(
      <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={4}
          >
       <Grid item xs={12}>

         <LSDBCoreTableNoSrink columns={columns} data={data} hiddenColumns={["Id"] }/>
       </Grid>
    </Grid>
      
    );


    
    
}


const handleDownload = (event: React.MouseEvent<HTMLButtonElement>) => {
  // Extract the data from the button's dataset
  const reportData = event.currentTarget.getAttribute("data-report");

  if (reportData) {
    const parsedData = JSON.parse(reportData);
    const downloadUrl = parsedData.azurefile_download; // Extract download URL

    if (downloadUrl) {
      // window.open(downloadUrl, "_blank"); // Open in a new tab
      // OR trigger a download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "file_name.ext"); // Set desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Download URL not found");
    }
  }else{
    toast.success("No report data found", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};